




















import DecorationSpeechBubble from "@/common/components/atoms/DecorationSpeechBubble.vue";

import { Prop, Vue, Component } from "vue-property-decorator";

@Component({
  components: {
    DecorationSpeechBubble
  }
})
export default class J05ChatScreenPanelMessageBody extends Vue {
  @Prop({ type: Object, required: true }) messageData!: any;
  @Prop({ type: Object, required: true }) classNameDirection!: any;
  @Prop({ type: Boolean, required: true }) isYouSent!: boolean;
  @Prop({ type: Boolean, required: true }) isSp!: boolean;

  classNameBase = {
    rootElement: "p-the-j05-chat-screen-panel-message-body",
    triangle: "p-the-j05-chat-screen-panel-message-body__triangle"
  };

  triangleDirection = {
    true: "right",
    false: "left"
  };

  get message() {
    return this.messageData.message;
  }
}
